import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

export default class extends Controller {
  connect() {
    this.picker = flatpickr(this.element, {
      // Add any flatpickr options here
      enableTime: false,
      dateFormat: "m/d/Y",
      allowInput: true
    });
  }

  disconnect() {
    if (this.picker) {
      this.picker.destroy();
    }
  }
}
